import React from 'react';
import Aux from '../../Hoc/Aux/Aux';
import classes from './Footer.css';
import FooterLink from './FooterLink/FooterLink';
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';

const footer = (props) => {
    return(
        <Aux>
            <section className={["section",classes.Section].join(' ')}>
                <div className="container">
                    <footer className={["footer", classes.Footer].join(' ')}>
                        <div className="container">
                            <div className="content has-text-centered">
                                <div className="columns" style={{borderBottom: '1px solid #4AADED'}}>
                                    <div className="column">
                                        <Logo />
                                    </div>
                                    <div className="column is-four-fifths">
                                       <div className="field is-horizontal">
                                           <div className="field-label is-normal">
                                               <label className="label" style={{textAlign: 'left', color: '#ffffff'}}>Get Our Email Newsletter!</label>
                                               <div className="field-body">
                                                   <div className="field">
                                                       <p className="control has-icon">
                                                           <input type="email" className="input is-expanded" placeholder="Recipient email"/>
                                                           <span className="icon is-small">
                                                               <i className="fa fa-envelope"></i>
                                                           </span>
                                                       </p>
                                                       <input type="submit" className="button" value="Sign Up"/>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                                    </div>
                                </div>

                                <div className="columns" style={{padding: '20px 0 20px 0'}}>
                                    <div className={["column", classes.Column].join(' ')}>
                                        <h4 className="title">GET STARTED</h4>
                                        <FooterLink link="/">Admission Process</FooterLink>
                                        <FooterLink link="/">talk to Advisor</FooterLink>
                                        <FooterLink link="/">Tour</FooterLink>
                                    </div>
                                    <div className={["column", classes.Column].join(' ')}>
                                        <h4 className="title">COMPANY</h4>
                                        <FooterLink link="/">About US</FooterLink>
                                        <FooterLink link="/">ProCode Staff</FooterLink>
                                        <FooterLink link="/">Careers</FooterLink>
                                        <FooterLink link="/">Information</FooterLink>
                                    </div>
                                    <div className={["column", classes.Column].join(' ')}>
                                        <h4 className="title">MORE</h4>
                                        <FooterLink link="/">Contact Us</FooterLink>
                                        <FooterLink link="/">FAQ</FooterLink>
                                        <FooterLink link="/">Employer Partnerships</FooterLink>
                                        <FooterLink link="/">Community Partnerships</FooterLink>
                                    </div>
                                    <div className={["column", classes.Column].join(' ')}>
                                        <h4 className="title">SOCIAL</h4>
                                        <li><Link to="https://www.facebook.com/JSReactCodingSchool/" target="_blank"><i className="fab fa-facebook"></i></Link></li>
                                        <li><Link to="https://www.linkedin.com/company/18581475/admin/overview/" target="_blank"><i className="fab fa-linkedin"></i></Link></li>
                                        <li><Link to="https://twitter.com/ProCodeBootCamp" target="_blank"><i className="fab fa-twitter-square"></i></Link></li>
                                        <li><Link to="https://www.instagram.com/procodebootcamp/" target="_blank"><i className="fab fa-instagram"></i></Link></li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                    <footer className={["footer", classes.Footer].join(' ')} style={{borderTop: '1px solid #4AADED'}}>
                        <div className="container">
                            <div className="content has-text-centered">
                                <p>
                                    &copy; 2018 ProCode. All rights reserved.
                                </p>
                            </div>
                        </div>
                    </footer>

                </div>
            </section>
        </Aux>
    )
};

export default footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js